import { render, staticRenderFns } from "./PgaAppBar.vue?vue&type=template&id=5f151242&"
import script from "./PgaAppBar.vue?vue&type=script&lang=ts&"
export * from "./PgaAppBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VAppBarNavIcon,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f151242')) {
      api.createRecord('5f151242', component.options)
    } else {
      api.reload('5f151242', component.options)
    }
    module.hot.accept("./PgaAppBar.vue?vue&type=template&id=5f151242&", function () {
      api.rerender('5f151242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Shared/Layout/PgaAppBar.vue"
export default component.exports